import * as React from 'react';
import {
	CheckboxGroup,
	FormCheckConditional,
	TextInput,
	Label
} from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const RespiratoryQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		return !props.questionnaire[questionName].isValid;
	};
	return (
		<div className="form-group mb-0">
			<Label>{props.questions[questionName]}</Label>
			<div className="section-base section-bordered mt-1 form-group">
				<CheckboxGroup
					title="Respiratory disorders, including:"
					className="mb-2"
					checkOptions={[
						{
							name: 'sleepApnea',
							label: 'Sleep apnea for which you are not treated',
							checked: props.questionnaire[questionName].sleepApnea,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'emphysema',
							label: 'Emphysema',
							checked: props.questionnaire[questionName].emphysema,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'tuberculosis',
							label: 'Tuberculosis',
							checked: props.questionnaire[questionName].tuberculosis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'sarcoidosis',
							label: 'Sarcoidosis',
							checked: props.questionnaire[questionName].sarcoidosis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'cysticFibrosis',
							label: 'Cystic fibrosis',
							checked: props.questionnaire[questionName].cysticFibrosis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'asthma',
							label: `Asthma requiring either a visit to the emergency room
								or the administration of oxygen within the past 12 months`,
							checked: props.questionnaire[questionName].asthma,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'copd',
							label: 'Chronic obstructive pulmonary disease (COPD)',
							checked: props.questionnaire[questionName].copd,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'respiratoryDisorderOther',
							label: 'Other',
							checked: props.questionnaire[questionName].respiratoryDisorderOther,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={props.questionnaire[questionName].respiratoryDisorderOther}>
									<TextInput
										labelText="Please specify:"
										name="respiratoryDisorderOtherDetails"
										onBlur={props.onQuestionnaireBlur}
										onChange={props.onQuestionnaireChange}
										value={props.questionnaire[questionName].respiratoryDisorderOtherDetails}
										className="mb-2"
									/>
								</FormCheckConditional>
							)
						},
						{
							name: 'respiratoryNone',
							label: 'None of the above apply to me',
							checked: props.questionnaire[questionName].respiratoryNone,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							className: 'border-top pt-2'
						},
					]}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

const questionName = 'respiratory';
const hocConfig = {
	questionName: questionName,
	otherName: 'respiratoryDisorderOther',
	otherDetailsName: 'respiratoryDisorderOtherDetails'
};
export default handleNoneOptionAndValidationHOC(RespiratoryQuestion, hocConfig);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion1/RespiratoryQuestion.tsx